import React, { useEffect, useState } from "react";
import { getAdaptiveSecurityAudits } from "../../api/adaptiveSecurityAuditService";

export default function AdaptiveSecurityAuditPage() {
    const [audits, setAudits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadAudits();
    }, []);

    const loadAudits = async () => {
        try {
            setLoading(true);
            setError("");

            const data = await getAdaptiveSecurityAudits();
            setAudits(data);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to load adaptive security audit."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-7xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-2xl font-bold mb-4">
                Adaptive Security Audit
            </h2>

            {loading && <p>Loading...</p>}
            {error && <p className="text-red-600 mb-3">{error}</p>}

            {!loading && audits.length === 0 ? (
                <p className="text-gray-500">No audit records found.</p>
            ) : (
                <table className="w-full border text-sm">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border p-2">ID</th>
                            <th className="border p-2">User</th>
                            <th className="border p-2">Shipment</th>
                            <th className="border p-2">Score</th>
                            <th className="border p-2">Risk</th>
                            <th className="border p-2">Access</th>
                            <th className="border p-2">2FA</th>
                            <th className="border p-2">Blocked</th>
                            <th className="border p-2">Reason</th>
                            <th className="border p-2">Blockchain Hash</th>
                            <th className="border p-2">Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        {audits.map((a) => (
                            <tr key={a.id}>
                                <td className="border p-2">{a.id}</td>
                                <td className="border p-2">
                                    {a.userName || a.userId || "�"}
                                </td>
                                <td className="border p-2">
                                    {a.shipmentId || "�"}
                                </td>
                                <td className="border p-2">
                                    {a.trustScore}
                                </td>
                                <td className="border p-2">
                                    {a.riskLevel}
                                </td>
                                <td className="border p-2">
                                    {a.allowAccess ? "Yes" : "No"}
                                </td>
                                <td className="border p-2">
                                    {a.requireTwoFactor ? "Required" : "No"}
                                </td>
                                <td className="border p-2">
                                    {a.blockOperation ? "Yes" : "No"}
                                </td>
                                <td className="border p-2">
                                    {a.reason || "�"}
                                </td>
                                <td className="border p-2 break-all">
                                    {a.blockchainHash || "�"}
                                </td>
                                <td className="border p-2">
                                    {a.createdAt
                                        ? new Date(a.createdAt).toLocaleString()
                                        : "�"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}